import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './business-sustainability.component.scss';
import { AnalyticsService } from '../../services/analytics.service';
import "bootstrap-datepicker";
var BusinessSustainability = /** @class */ (function (_super) {
    tslib_1.__extends(BusinessSustainability, _super);
    function BusinessSustainability(element) {
        return _super.call(this, element) || this;
    }
    BusinessSustainability.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js_submit-button"));
        if (this.applyForm) {
            this.displayLoader = this.applyForm.querySelector(".form-container__loader");
            this.displayFields = this.applyForm.querySelector(".form-container__fields");
            this.displaySuccess = this.applyForm.querySelector(".form-container__success");
            this.displayFail = this.applyForm.querySelector(".form-container__error");
        }
        this.containerModal = this.element.closest('.business-sustainability');
        this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');
        this.backButton = this.containerModal.querySelector('.js_back-button');
        this.initFieldLengths();
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-email");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingEmailTextArea = this.element.querySelector(".data-sharing-sms");
        this.provinceField = this.applyForm.querySelector('select[name=select-province]');
        this.otherCountryWrapper = this.applyForm.querySelector('.other-country-field-wrapper');
        this.otherCountryInput = this.applyForm.querySelector('input[name=other-country]');
        this.doneSubmit = this.element.querySelector(".js_done-button");
        if ((typeof dataLayer != 'undefined')) {
            dataLayer.application.applicationName = "Business Sustainability";
        }
    };
    BusinessSustainability.prototype.bindEvents = function () {
        var _this = this;
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
        this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
            _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute("hidden");
            _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsShowBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute("hidden");
            _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailShowBtn.removeAttribute("hidden");
        });
        if (this.provinceField) {
            this.provinceField.addEventListener('change', function (e) { return _this.toggleOtherCountryField(); });
            this.toggleOtherCountryField();
        }
        this.applyFormSubmit.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select, textarea");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        if (this.backButton) {
            this.backButton.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        // Reset the form
        this.applyForm.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
        if (this.applyForm) {
            var _formFields = Array.from(this.applyForm.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.element.querySelector('input[name=business-reg-number]').addEventListener('input', function (e) {
            var value = e.target.value;
            // Remove all non-numeric characters
            value = value.replace(/[^0-9]/g, '');
            // Apply the formatting
            if (value.length > 10) {
                value = value.slice(0, 4) + '/' + value.slice(4, 10) + '/' + value.slice(10, 12);
            }
            else if (value.length > 4) {
                value = value.slice(0, 4) + '/' + value.slice(4);
            }
            e.target.value = value;
        });
    };
    BusinessSustainability.prototype.toggleOtherCountryField = function () {
        if (!this.provinceField || !this.otherCountryWrapper || !this.otherCountryInput) {
            return;
        }
        var showOther = this.provinceField.value === 'Other Country';
        if (showOther) {
            this.otherCountryWrapper.removeAttribute('hidden');
            this.otherCountryInput.disabled = false;
            this.otherCountryInput.setAttribute('required', 'true');
            this.otherCountryInput.classList.add('form__input--required');
        }
        else {
            this.otherCountryWrapper.setAttribute('hidden', 'true');
            this.otherCountryInput.disabled = true;
            this.otherCountryInput.removeAttribute('required');
            this.otherCountryInput.classList.remove('form__input--required');
            this.otherCountryInput.value = '';
        }
    };
    BusinessSustainability.prototype.initFieldLengths = function () {
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        _firstName.setAttribute("maxlength", "80");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        _surname.setAttribute("maxlength", "80");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNum]");
        _contactNumber.setAttribute("maxlength", "10");
        var _reason = this.applyForm.querySelector("textarea[name=reason]");
        _reason.setAttribute("maxlength", "500");
    };
    BusinessSustainability.prototype.validSAContact = function (field) {
        var is_zero_number_correct = true;
        var num;
        num = /^0[0-9]\d{8}$/g;
        if (num.test(field.value) === false) {
            is_zero_number_correct = false;
        }
        else {
            is_zero_number_correct = true;
        }
        return is_zero_number_correct;
    };
    BusinessSustainability.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.remove("active");
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.remove("active");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.remove("active");
        this.displaySuccess.classList.add("hidden");
        this.displayFail.classList.remove("active");
        this.displayFail.classList.add("hidden");
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.add("active");
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.add("active");
                this.displaySuccess.classList.remove("hidden");
                break;
            case "fail":
                this.displayFail.classList.add("active");
                this.displayFail.classList.remove("hidden");
                break;
            default:
                this.displayLoader.classList.add("active");
                this.displayLoader.classList.remove("hidden");
                break;
        }
    };
    BusinessSustainability.prototype.closeForm = function () {
        var baseUrl = document.querySelector('input[name=productPage]');
        window.location.href = baseUrl.value || '/southafrica/business';
    };
    BusinessSustainability.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            this.showDisplayView("fields");
        }
    };
    BusinessSustainability.prototype.submitForm = function (form) {
        var _this = this;
        var _displayName = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var analyticsService = new AnalyticsService();
        var _subject = this.applyForm.querySelector("input[name=subject]");
        var _product = this.applyForm.querySelector("input[name=product]");
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNum]");
        var _email = this.applyForm.querySelector("input[name=emailAddress]");
        var _recipient = this.applyForm.querySelector("input[name=recipient]");
        var _mailBoxEmail = this.applyForm.querySelector("input[name=email]");
        var _businessName = this.applyForm.querySelector("input[name=business-name]");
        var _businessRegNumber = form.querySelector("input[name=business-reg-number]");
        var _province = form.querySelector("select[name=select-province]");
        var _otherCountry = form.querySelector("input[name=other-country]");
        var _reason = form.querySelector("textarea[name=reason]");
        var _popiConsent = this.applyForm.querySelector("input[name=popia-consent]");
        var errors = [];
        if (_contactNumber.value.length != 10) {
            errors.push('South African contact numbers are 10 digits');
        }
        if (!this.validSAContact(_contactNumber)) {
            errors.push('This contact number is invalid');
        }
        if (errors.length !== 0) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            this.validationService.addErrorMessage(_contactNumber, errors);
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }
        var _postData = {
            subject: (_subject ? _subject.value : ""),
            product: (_product ? _product.value : ""),
            firstName: (_firstName ? _firstName.value : ""),
            surname: (_surname ? _surname.value : ""),
            emailAddress: (_email ? _email.value : ""),
            recipient: (_recipient ? _recipient.value : ""),
            email: (_mailBoxEmail ? _mailBoxEmail.value : ""),
            contactNo: (_contactNumber ? _contactNumber.value : ""),
            businessName: (_businessName ? _businessName.value : ""),
            province: (_province ? _province.value : ""),
            country: ((_province && _province.value === 'Other Country') ? ((_otherCountry && _otherCountry.value.trim()) ? _otherCountry.value : "South Africa") : "South Africa"),
            businessRegNumber: (_businessRegNumber ? _businessRegNumber.value : ""),
            reason: (_reason ? _reason.value : ""),
            dataPrivacyConsent: ((_popiConsent && _popiConsent.checked) ? "YES" : "NO"),
            dataSharingGroup: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-group'),
            dataSharing3rdParty: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-3rd-party'),
            dataSharingBoarders: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-boarders'),
            dataSharingTelesale: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-telesale'),
            dataSharingEmail: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-email'),
            dataSharingSms: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-sms'),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/business-sustainability-leads";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        this.formsService.postForm(url, _postData, _config).then(function (response) {
            var _response = response.data;
            if (_response.toString().includes('invalid')) {
                analyticsService.dtmFormComplete("complete", "false");
                _this.showDisplayView("fail");
            }
            else {
                if (_displayName) {
                    _displayName.map(function (pElement) {
                        pElement.innerHTML = _postData.firstname;
                    });
                }
                analyticsService.dtmFormComplete("complete", "true");
                _this.showDisplayView("success");
                window.scroll({ top: 0, behavior: "smooth" });
            }
        }).catch(function (response) {
            analyticsService.dtmFormComplete("complete", "false");
            this.showDisplayView("fail");
        });
    };
    return BusinessSustainability;
}(Base));
export { BusinessSustainability };



//////////////////
// WEBPACK FOOTER
// ./components/business-sustainability/business-sustainability.component.ts
// module id = 1127
// module chunks = 0